import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Store } from '@ngxs/store';
import { FetchBalanceEntries } from '../../states/climateEntries/climate-entries.actions';

export const resolveClimateEntries: ResolveFn<void> = () => {
  const store: Store = inject(Store);
  return store.dispatch(new FetchBalanceEntries());
};
